<app-caricamento *ngIf="loading"></app-caricamento>
<div *ngIf="checkAbilitato && abilitato && !loading" class="w-100">
    <div class="box__container" *ngIf="sezione && (sezione.titolo || sezione.sottotitolo)">
        <div class="box__title">
            {{sezione.titolo}}
        </div>
        <div class="box__subtitle">
            {{sezione.sottotitolo}}
        </div>
    </div>
    <div class="filtri__wrapper" *ngIf="showFiltro">
        <div class="chips__container" *ngIf="regioni && regioni.length > 1" (click)="setVisibleFiltro(1)"
            [ngClass]="getVisibleFiltro(1) ? 'active' : 'not-active'">
            <div class="chips__header">
                <div class="chips__label">
                    Regioni
                </div>
                <span class="chips__icon material-symbols-outlined">
                    place
                </span>
            </div>
            <div class="chips__active" *ngIf="getAttivoFiltro(1)"></div>
        </div>
        <div class="chips__wrapper" *ngIf="getVisibleFiltro(1)">
            <div class="chips__item" *ngFor="let regione of regioni" (click)="filtra(1, regione)"
                [ngClass]="filtroRegione.idRegione === regione.idRegione ? 'active' : 'not-active'">
                <span *ngIf="!regione.traduzione">
                    {{regione.regione}}
                </span>
                <span *ngIf="regione.traduzione">
                    {{regione.regione | translate}}
                </span>
            </div>
        </div>
        <div class="chips__container" *ngIf="tipivisite && tipivisite.length > 0" (click)="setVisibleFiltro(2)"
            [ngClass]="getVisibleFiltro(2) ? 'active' : 'not-active'">
            <div class="chips__header">
                <div class="chips__label">
                    Tipologie
                </div>
                <span class="chips__icon material-symbols-outlined">
                    diversity_1
                </span>
            </div>
            <div class="chips__active" *ngIf="getAttivoFiltro(2)"></div>
        </div>
        <div class="chips__wrapper" *ngIf="getVisibleFiltro(2)">
            <div class="chips__item" *ngFor="let tipologia of tipologie" (click)="filtra(2, tipologia)"
                [ngClass]="filtroTipologia.idTipologia === tipologia.idTipologia ? 'active' : 'not-active'">
                {{tipologia.label | translate}}
            </div>
        </div>
    </div>
    <app-tipi-visite-layout-base [tipivisite]="tipovisiteFiltered" [linguaCorrente]="linguaCorrente"
        [codiceForm]="codiceForm" [cart]="carrello" [collegate]="true"
        *ngIf="layout == 1 && tipovisiteFiltered.length > 0"></app-tipi-visite-layout-base>
    <app-tipi-visite-layout-colonne [tipivisite]="tipovisiteFiltered" [linguaCorrente]="linguaCorrente"
        [codiceForm]="codiceForm" [cart]="carrello" [collegate]="true" [base]="false"
        *ngIf="layout == 2 && tipovisiteFiltered.length > 0"></app-tipi-visite-layout-colonne>
    <app-nessun-risultato [tipologia]="'visite'" *ngIf="tipovisiteFiltered.length == 0"></app-nessun-risultato>
    <app-footer [caricamento]="false"></app-footer>
</div>
<div *ngIf="checkAbilitato && !abilitato && !loading">
    <app-disabilitato [pagina]="'collegate'"></app-disabilitato>
</div>